import { SchemaService } from "@/shared/services/SchemaService";
import { CustomReportSchema } from "../models/CustomReportSchema";
import { CustomReportsService } from "./CustomReportsService";



export class CustomReportSchemaService extends SchemaService<CustomReportSchema> {

    static readonly injectableKey = 'CustomReportSchemaService';

    get injectableKey() {
        return (this.constructor as typeof CustomReportSchemaService).injectableKey;
    }

    public cdnContentPath: string = "custom_reports/reports_schemas";

    public getInternalSchemas(): Array<CustomReportSchema> {

        const internalCustomReportSchemas = [
            {
                "type": `${CustomReportsService.CUSTOM_CUSTOMREPORT_TYPE}`,
                "display_name": "Unknown CustomReport",
                "description": "Add unknown CustomReport",
                "category": "Custom",
                "is_visible": false,
                "fields": [
                    {
                        "name": "value",
                        "display_name": "Json",
                        "field_type": "json",
                        "required": true,
                        "description": "Json Value"
                    }
                ],
                "examples": [
                    {
                        "type": "json"
                    }
                ]
            },
        ] as Array<CustomReportSchema>;

        return internalCustomReportSchemas;

    }

}
